import "@ramudden/core/extensions";
import "prismjs";
import "prismjs/components/prism-csharp";
import "prismjs/components/prism-json";

import "@angular/common/locales/global/de";
import "@angular/common/locales/global/en";
import "@angular/common/locales/global/fr";
import "@angular/common/locales/global/nl";
import "@angular/common/locales/global/no";
import "@angular/common/locales/global/sv";
import { ApplicationRef, enableProdMode } from "@angular/core";
import { enableDebugTools, bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .then((appRef: ApplicationRef) => {
        if (!environment.production) {
            const componentRef = appRef.components[0];

            // allows to run `ng.profiler.timeChangeDetection();`
            enableDebugTools(componentRef);
        }
    })
    .catch((err) => console.error(err));

